/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ArrowDropDownCircle } from "@material-ui/icons";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { useState } from "react";

function AccordionSectionDisplay (props) {

    const {
        section,
        tabIndex = 0,
        group_id,
        expanded,
        handleExpandChange,
        stepNumber,
        showSteps
    } = props;

    const {
        tab_id: editor_id,
        title,
        richtext: defaultRichText,
    } = section;

    const [richtext] = useState(defaultRichText);
    const panel = `accordion-${group_id}-${tabIndex}`;
    const identifier = `accordion-${section.tab_id}`;

    return (
        <div className='accordion-container'>
            {showSteps && (
                <div className='step-container'>
                    <h6>{stepNumber}</h6>
                </div>
            )}

            <Accordion
                className='accordion'
                expanded={expanded === identifier}
                onChange={handleExpandChange(identifier)}
                sx={{ marginBottom: "9px", border: "1px solid #e0e0e0", width: "100%" }}
            >
                <AccordionSummary
                    expandIcon={<ArrowDropDownCircle />}
                    aria-controls={panel}
                    id={editor_id}
                    sx={{
                        backgroundColor: "#f9f9f9",
                        height: "48px",
                    }}
                >
                    <h5>{title}</h5>
                </AccordionSummary>

                <AccordionDetails>
                    <div style={{ padding: "12px 18px" }}>
                        <RichTextPreview richtext={richtext} />
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default AccordionSectionDisplay;
